import { localBlockComponents } from "../local/registry-block";
import { Content } from "./Content.component";

export const embedBlockComponents = {
  ...localBlockComponents,
  item: () => Content,
};
